import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "./globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "./utils.service";
export class CostFormService extends BaseProvider {
    constructor(globals, http, utils) {
        super();
        this.globals = globals;
        this.http = http;
        this.utils = utils;
        this.costs = [];
        this.selectedCosts = [];
        this.dynamicCosts = [];
        this.subTotal = 0;
        this.total = 0;
        this.taxAmount = 0;
        this.discountAmount = 0;
        this.costsAdded = true;
        this.dynamicCostsAdded = false;
        this.minimumCostsAdded = false;
        this.minimumCostSelectedCount = 0;
        this.minRequiredCosts = [];
        // Cost rules validation
        this.costRulesConfiguration = null;
        this.costRulesValidationError = '';
        this.isCostRulesValid = true;
        this.baseUrl = 'userProcessCost';
    }
    save(processId, data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + "/" + processId;
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    createNonDynamicCosts(processId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + "/noDynamicCosts/" + processId;
            this.http
                .post(this.url, null)
                .subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    getCosts(processId, costTypeId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/${processId}` + `/costType/${costTypeId}`;
            this.http.get(this.url).subscribe((data) => {
                console.log('getCosts API response:', data);
                this.costs = data.Data;
                this.costsAdded = true;
                // Parse CostRulesConfiguration from first cost item (rules are same for all)
                this.costRulesConfiguration = null;
                if (data.Data && data.Data.length > 0 && data.Data[0].CostRulesConfiguration) {
                    const rulesConfig = data.Data[0].CostRulesConfiguration;
                    console.log('CostRulesConfiguration from API:', rulesConfig);
                    try {
                        this.costRulesConfiguration = typeof rulesConfig === 'string'
                            ? JSON.parse(rulesConfig)
                            : rulesConfig;
                        console.log('Parsed CostRulesConfiguration:', this.costRulesConfiguration);
                    }
                    catch (e) {
                        console.error('Error parsing CostRulesConfiguration:', e);
                    }
                }
                resolve(data.Data);
            }, (err) => {
                this.costsAdded = false;
                reject(err);
            });
        });
    }
    getDynamicCosts(invoiceId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/dynamic/invoice/${invoiceId}`;
            this.http.get(this.url).subscribe((data) => {
                this.dynamicCosts = data.Data;
                for (var i = 0; i < this.dynamicCosts.length; i++) {
                    this.dynamicCosts.Costs = JSON.parse(this.dynamicCosts[i].Costs);
                }
                console.log(this.dynamicCosts.Costs);
                resolve(this.dynamicCosts);
            }, (err) => {
                reject(err);
            });
        });
    }
    getInvoiceDetail(processId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/invoice/detail/process/${processId}`;
            this.http.get(this.url).subscribe((data) => {
                this.dynamicCosts = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    manageCost(obj) {
        let foundItem = this
            .utils
            .returnItemFromListByAttr(this.selectedCosts, "Id", obj.cost.Id);
        if (!this.utils.isEmpty(foundItem)) {
            this
                .utils
                .updateItemFromListByAttr(this.selectedCosts, "Id", Object.assign({}, obj.cost, { Qty: parseInt(obj.qty) }));
        }
        else {
            this.selectedCosts.push(Object.assign({}, obj.cost, { Qty: parseInt(obj.qty) }));
        }
    }
    removeCost(cost) {
        this
            .utils
            .removeItemFromListByAttr(this.selectedCosts, "Id", cost);
    }
    setTotal() {
        this.subTotal = 0;
        this.selectedCosts.forEach((element, index) => {
            var amount = (element.FixedAmount > 0) ? element.FixedAmount : element.Amount;
            this.subTotal += (amount * element.Qty);
        });
        this.total = this.subTotal;
        this.total = this.total + this.taxAmount;
        this.setDiscount();
    }
    setDiscount() {
        if (this.discountAmount <= this.subTotal) {
            this.total = (this.subTotal - this.discountAmount) + this.taxAmount;
        }
    }
    setInvoiceTotal() {
        this.subTotal = 0;
        this.selectedCosts.forEach((element, index) => {
            var amount = (element.FixedAmount > 0) ? element.FixedAmount : element.Amount;
            this.subTotal += (amount * element.Qty);
        });
        this.total = this.subTotal;
        this.total = this.total + this.taxAmount;
        this.dynamicCostsAdded = false;
        if (this.total > 0) {
            this.dynamicCostsAdded = true;
        }
        this.setDiscount();
    }
    /**
     * Validates the current selection against cost rules configuration
     * Returns true if valid, false if invalid
     */
    validateCostRules() {
        this.costRulesValidationError = '';
        this.isCostRulesValid = true;
        if (!this.costRulesConfiguration || !this.costRulesConfiguration.costCalculatorRules) {
            return true;
        }
        // Count non-required selected costs (user selections only)
        const userSelectedCount = this.selectedCosts.filter(c => !c.IsRequired).length;
        for (const rule of this.costRulesConfiguration.costCalculatorRules) {
            const minAllowed = rule.minCostAllowed ? rule.minCostAllowed : 0;
            const maxAllowed = rule.maxCostAllowed ? rule.maxCostAllowed : Infinity;
            if (userSelectedCount < minAllowed) {
                this.costRulesValidationError = `Debe seleccionar al menos ${minAllowed} costo(s).`;
                this.isCostRulesValid = false;
                return false;
            }
            if (userSelectedCount > maxAllowed) {
                this.costRulesValidationError = `Debe seleccionar un máximo de ${maxAllowed} costo(s).`;
                this.isCostRulesValid = false;
                return false;
            }
        }
        return true;
    }
}
CostFormService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CostFormService_Factory() { return new CostFormService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.UtilsService)); }, token: CostFormService, providedIn: "root" });
